import { LitElement, html, css } from 'lit'

class FormContainer extends LitElement {
  static styles = css`
    :host[hidden] {
      display: none;
    }

    .response-message {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin-top: 3rem;
    }

    .response-message-text {
      color: hsl(var(--theme-400));
      font: var(--display-5);
      margin-bottom: 4rem;
    }

    .response-message-icon {
      --icon-width: 5rem;
      --icon-stroke-color: hsla(var(--theme-600));
      --icon-stroke-width: 1.7;
    }
  `

  static get properties() {
    return {
      success: {},
      formSent: { type: Boolean },
      formError: { type: Boolean },
    }
  }

  constructor() {
    super()
    this.form = this.querySelector('form')
    this.submitButton = this.querySelector('button[type="submit"]')
    this.action = this.form.getAttribute('action')
    this.formSent = false

    var inputElement = document.getElementById("vatno");

    if (inputElement) {
      inputElement.addEventListener("input", function() {
        if (!inputElement.checkValidity()) {
          inputElement.reportValidity();
          inputElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    }
    this.form.addEventListener('submit', this.submitForm.bind(this))
  }

  connectedCallback() {
    super.connectedCallback()
  }

  submitForm(e) {
    e.preventDefault()
    if (this.form.getAttribute('aria-busy') === 'true') return

    this.form.setAttribute('aria-busy', 'true')
    this.submitButton.setAttribute('aria-busy', 'true')

    const formData = new FormData(this.form)

    fetch(this.action, {
      method: 'POST',
      headers: {
        // 'Content-Type': 'multipart/form-data',
        'x-requested-with': 'XMLHttpRequest',
      },
      body: formData,
    })
      .then((response) => {
        if (response.ok) {
          this.formSent = true
          window.scrollTo(
            0,
            this.getBoundingClientRect().top +
              document.documentElement.scrollTop -
              200
          )
        } else {
          this.formError = true
          console.error(response)
        }
      })
      .catch((error) => {
        this.formError = true
        console.error(error)
      })
      .finally(() => {
        this.form.removeAttribute('aria-busy')
        this.submitButton.removeAttribute('aria-busy')
      })
  }

  render() {
    if (this.formSent) {
      return html` <div>
        <div class="response-message" part="response-message">
          <send-icon
            class="response-message-icon"
            part="response-message-icon"
          ></send-icon>
          <p class="response-message-text" part="response-message-text">
            ${this.dataset.sentmessage}
          </p>
        </div>
      </div>`
    }
    if (this.formError) {
      return html` <div>
        <div class="response-message" part="response-message">
          <p class="response-message-text" part="response-message-text">
            ${this.dataset.errormessage}
          </p>
        </div>
      </div>`
    }
    return html` <slot></slot>`
  }
}

customElements.define('form-container', FormContainer)
